export default __webpack_public_path__ + "static/media/team-photo-2013.5349eb98.jpg";